import { useGoogleTagManager } from '../../hooks/useGoogleTagManager';

interface GTMComponentProps {
  appId: string;
}

export const GTMComponent: React.FC<GTMComponentProps> = ({ appId }) => {
  useGoogleTagManager(appId);
  return null; // This component doesn't render anything
};